import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {InputField} from '@Components/input-field-v2';
import type {InputFieldControls, InputFieldHandlers, InputType} from '@Components/input-field-v2/input-field.types';
import {InputFieldSize, InputFieldState} from '@Components/input-field-v2/input-field.types';
import styles from './contextual-menu-inputs-option.module.scss';

interface ContextualMenuInputsOptionProps extends InputFieldHandlers {
  id: string;
  className?: string;
  value?: InputType;
  optionTag?: ReactNode;
  optionlabel?: string;
  inputLabel?: string;
  placeholder?: string;
  hasIcon?: string;
  controls?: InputFieldControls;
  showErrorState?: boolean;
  errorText?: string;
  size?: InputFieldSize;
  isMultiline?: boolean;
  maxNumberOfRows?: number;
  maxLength?: number;
  isControlled?: boolean;
  isDisabled?: boolean;
  elementTitle?: string;
  selectOnFocus?: boolean;
  refObject?: React.Ref<HTMLInputElement | HTMLTextAreaElement>;
}

export function ContextualMenuInputsOption({
  className = '',
  hasIcon = '',
  placeholder = '',
  inputLabel = '',
  onInputChange = (): void => {},
  onInputChangeEnded = (): void => {},
  onInputFocus = (): void => {},
  onInputBlur = (): void => {},
  onInputSubmit = (): void => {},
  showErrorState = false,
  errorText = '',
  elementTitle = '',
  isControlled = true,
  isDisabled = false,
  size = InputFieldSize.SMALL,
  ...props
}: ContextualMenuInputsOptionProps): ReactElement<any> {
  return (
    <Option
      key={props.id}
      label={props.optionlabel}
      tag={props.optionTag}
      className={`${styles.inputField} ${className}`}
      optionItemsHaveGap={!inputLabel}
      optionControl={
        <InputField
          ref={props.refObject}
          id={props.id}
          size={size}
          hasIcon={hasIcon}
          label={inputLabel}
          placeholder={placeholder}
          onInputChange={(value): void => {
            return onInputChange(value);
          }}
          elementTitle={elementTitle}
          onInputFocus={onInputFocus}
          onInputBlur={onInputBlur}
          onInputSubmit={onInputSubmit}
          onInputChangeEnded={onInputChangeEnded}
          input={props.value}
          controls={props.controls}
          state={showErrorState ? InputFieldState.ERROR : InputFieldState.DEFAULT}
          information={showErrorState ? errorText : ''}
          isMultiline={props.isMultiline}
          maxLength={props.maxLength}
          maxNumberOfRows={props.maxNumberOfRows}
          isControlled={isControlled}
          isDisabled={isDisabled}
          selectOnFocus={props.selectOnFocus}
        />
      }
    />
  );
}
